export default __webpack_public_path__ + "static/media/Img3.aed451fb.png";